/** @enum {number} */
const UpscalerType = Object.freeze({
    ANIME: "waifu2x",
    ESRGAN: "real-esrgan"
})

export default UpscalerType;